import script from "./VitaEmptyPlaceholder.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaEmptyPlaceholder.vue?vue&type=script&lang=ts&setup=true"

import "./VitaEmptyPlaceholder.vue?vue&type=style&index=0&id=212d0db2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212d0db2"]])

export default __exports__